import React from 'react';
import * as Sentry from '@sentry/react';
import mixpanel from 'mixpanel-browser';

export class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { error: null, eventId: null };
	}

	componentDidCatch(error, errorInfo) {
		this.setState({ error });
		mixpanel.track('Error shown', {
			distinct_id: mixpanel.get_distinct_id(),
			'Error message': error.message,
			...errorInfo
		});
		Sentry.withScope((scope) => {
			scope.setExtra('errorInfo', errorInfo);
			const eventId = Sentry.captureException(error);
			this.setState({ eventId });
		});
	}

	render() {
		if (this.state.error) {
			return (
				<div className="flex min-h-screen flex-col items-center justify-center gap-3 bg-background px-6 text-center">
					<h1 className="text-2xl font-bold text-foreground">Sorry!</h1>
					<p className="text-sm text-muted-foreground">An unexpected error occurred. Our team has been notified.</p>
					<div className="mt-4 flex gap-4 text-sm font-semibold text-primary">
						<a href="/" className="hover:underline">
							Go back
						</a>
						<button
							type="button"
							onClick={() => Sentry.showReportDialog({ eventId: this.state.eventId })}
							className="hover:underline"
						>
							Report feedback
						</button>
					</div>
				</div>
			);
		}

		return this.props.children;
	}
}
